export default function MarketingIco ({icon}) {
    return (
        icon.meta?.odkaz ? (
            <a href={icon.meta.odkaz} target="_blank"
               className="d-block h-100 bg-gray-900 card p-2 text-center">
                {icon.meta.ikonka_ze_sablony != "" ? (
                    <div className="text-center">
                        <i className={"ki-solid " + icon.meta.ikonka_ze_sablony + " fs-1 "}>
                        </i>
                    </div>
                ) : (
                    icon.meta.ikonka?.guid && <img src={icon.meta.ikonka?.guid} className="img-fluid"/>
                )}
                <div className="fs-9">{icon.title?.rendered}</div>
            </a>
        ) : (

            <div className="h-100 bg-gray-900 card p-2 text-center">
                {icon.meta.ikonka_ze_sablony != "" ? (
                    <div className="text-center">
                        <i className={"ki-solid " + icon.meta.ikonka_ze_sablony + " fs-1 "}>
                        </i>
                    </div>
                ) : (
                    icon.meta.ikonka?.guid && <img src={icon.meta.ikonka?.guid} className="img-fluid"/>
                )}
                <div className="fs-9">{icon.title?.rendered}</div>
            </div>
        )
    );
}